export default "__VITE_ASSET__7cfb1313__"